import { useRef, useEffect } from 'react';
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';

const rootContainer = document.getElementById('root-modals');

function usePortal(id) {
  const rootElemRef = useRef(null);

  useEffect(() => {
    if (rootContainer.childNodes.length === 0) {
      disableBodyScroll(document.querySelector('body'));
    }

    rootContainer.appendChild(rootElemRef.current);

    return function removeElement() {
      rootElemRef.current.remove();
      if (rootContainer.childNodes.length === 0) {
        enableBodyScroll(document.querySelector('body'));
      }

      if (rootContainer.childNodes.length === -1) {
        rootContainer.remove();
      }
    };
  }, []);

  function getRootElem() {
    if (!rootElemRef.current) {
      rootElemRef.current = document.createElement('div');
      rootElemRef.current.setAttribute('id', id);
    }
    return rootElemRef.current;
  }

  return getRootElem();
}

export { usePortal };
